import {alias, createModelSchema, list, primitive, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {RedactorUtils} from "../../core/RedactorUtils";
import {Schema} from "@/common/Schema";

export class TriggerProduct extends TriggerBase {

    constructor() {
        super(TriggerKind.PRODUCT);
        this._product = null;
        this._groups = [];
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get groups() {
        return this._groups;
    }

    set groups(value) {
        this._groups = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (this.product && !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        if (!this.product && this.groups.length === 0) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerProduct());
        } else if (target instanceof TriggerProduct) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerProductScope extends TriggerScope {

    static _values = [
        new TriggerProductScope(1, "PURCHASE"),
        new TriggerProductScope(6, "PURCHASE_FREE"),
        new TriggerProductScope(7, "PURCHASE_CASH"),
        new TriggerProductScope(8, "PURCHASE_STORE"),

        new TriggerProductScope(2, "CONSUMED"),
        new TriggerProductScope(3, "BOUGHT"),
        new TriggerProductScope(5, "WAS_BOUGHT"),
        new TriggerProductScope(4, "FREE_USE")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerProductScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerProductScope());
        } else if (target instanceof TriggerProductScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerProduct, {
    _scope: alias("scope", TriggerProductScope.schema()),
    _groups: alias("product_groups", list(primitive())),
    _product: alias("product_uid", Schema.primitive())
});
